import { TenantPartnershipId } from "@sp-crm/core";
import {
    Popover,
    PopoverButton,
    PopoverPanel,
} from "lib/headlessui/components/popover/popover";
import React from "react";
import { SharedChipContent, sharedChipClassName } from "./shared-chip";

export interface OutgoingSharesIndicatorSource {
    partnershipId: TenantPartnershipId;
    receivingTenantName: string;
}

const label = "Shared";

const buttonClassName = `${sharedChipClassName} hover:bg-brand-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500`;

const panelClassName =
    "z-[1600] w-64 rounded-xl bg-white p-3 shadow-lg ring-1 ring-zinc-950/10 [--anchor-gap:--spacing(2)] [--anchor-padding:--spacing(4)]";

export const OutgoingSharesIndicator: React.FC<{
    shares: OutgoingSharesIndicatorSource[];
}> = ({ shares }) => {
    if (shares.length === 0) {
        return null;
    }
    return (
        <Popover className="relative inline-block">
            <PopoverButton className={buttonClassName} aria-label={label}>
                <SharedChipContent label={label} />
            </PopoverButton>
            <PopoverPanel anchor="bottom start" className={panelClassName}>
                <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    This pipeline is shared with
                </div>
                <ul className="mt-2 space-y-1 text-sm text-gray-900">
                    {shares.map(share => (
                        <li key={share.partnershipId}>{share.receivingTenantName}</li>
                    ))}
                </ul>
            </PopoverPanel>
        </Popover>
    );
};
